import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Index";
import { getMyCrewMemberId } from "./components/useCrewTask";
import DashboardWidgetRenderer from "../configurations/dashboard-widgets/DashboardWidgetRenderer";

const Sales = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [crewMemberId, setCrewMemberId] = useState<number | null>(null);

  const userId = useSelector((state: RootState) => state.auth.user?.id);

  useEffect(() => {
    if (userId) {
      getMyCrewMemberId(userId).then((id) => setCrewMemberId(id));
    }
  }, [userId]);

  return (
    <DashboardWidgetRenderer
      dashboardKey="sales"
      widgetProps={{
        selectedDate,
        onDateSelect: setSelectedDate,
        crewMemberId,
      }}
    />
  );
};

export default Sales;